import { FormControl, InputLabel } from '@mui/material';
import React from 'react';
import { ChromePicker } from 'react-color';
import { Control, Controller } from 'react-hook-form';

interface ColorPickerProps {
  name: string;
  label: string;
  control: Control<any>;
}
export const ColorPicker: React.FC<ColorPickerProps> = ({
  name,
  label,
  control,
}) => {
  return (
    <Controller
      name={name}
      render={({ field: { onChange, value } }) => (
        <FormControl focused variant="outlined">
          <InputLabel htmlFor={name}>{label}</InputLabel>
          <ChromePicker
            onChange={(props: { hex: string }) => onChange(props.hex)}
            color={value}
            disableAlpha
            styles={{
              default: { picker: { boxShadow: 'none', padding: '6px' } },
            }}
          />
        </FormControl>
      )}
      control={control}
    />
  );
};
